import { LevelOfService } from '../../../../slices/marketplace/timeline/models/enums/level-of-service.enum';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';

export enum MarketplaceCommsHubTab {
    BrokerChat = 1,
    BuyerCommunications = 2,
    Meetings = 3,
}

export const MarketplaceCommsHubTabs = [
    {
        id: MarketplaceCommsHubTab.BrokerChat,
        content: 'Advisor Chat',
        parties: [
            { party: TimelineParty.Broker },
            { party: TimelineParty.Seller },
            { party: TimelineParty.VetValue },
        ],
        for: [LevelOfService.FullServiceBrokerage, LevelOfService.StrategicFinancialAdvisoryService],
    },
    {
        id: MarketplaceCommsHubTab.BuyerCommunications,
        content: 'Buyer Chat',
        parties: [
            { party: TimelineParty.Buyer, name: 'Seller Chat' },
            { party: TimelineParty.Seller },
            { party: TimelineParty.Broker },
            { party: TimelineParty.VetValue },
        ],
        for: [
            LevelOfService.FullServiceBrokerage,
            LevelOfService.DiscountBrokerage,
            LevelOfService.StrategicFinancialAdvisoryService,
        ],
    },
    {
        id: MarketplaceCommsHubTab.Meetings,
        content: 'Meetings',
        parties: [
            { party: TimelineParty.Buyer },
            { party: TimelineParty.Seller },
            { party: TimelineParty.Broker },
        ],
        for: [
            LevelOfService.FullServiceBrokerage,
            LevelOfService.DiscountBrokerage,
            LevelOfService.StrategicFinancialAdvisoryService,
        ],
    },
];

export const getMarketplaceCommsHubTabs = (
    party: TimelineParty,
    levelOfService: LevelOfService,
    isAnyDataNdaSigned: boolean,
    isBrokerChatAvailable: boolean
) => {
    return MarketplaceCommsHubTabs.filter(
        (tab) =>
            tab.parties.some((p) => p.party === party) &&
            tab.for.includes(levelOfService) &&
            (tab.id !== MarketplaceCommsHubTab.BuyerCommunications ||
                isAnyDataNdaSigned ||
                party === TimelineParty.Buyer) &&
            tab.id !== MarketplaceCommsHubTab.Meetings &&
            (tab.id !== MarketplaceCommsHubTab.BrokerChat ||
                isBrokerChatAvailable)
    ).map((t) => {
        const text =
            t.parties.find((p) => p.party === party)?.name || t.content;
        return { id: t.id, content: text };
    });
};
